/* eslint-disable @typescript-eslint/only-throw-error -- redirect é o contrato do TanStack Router */
import { createFileRoute, redirect } from '@tanstack/react-router';
// Aba por caminho no legado (router.tsx:1970-1979) vira `?tab=` (S29).
export const Route = createFileRoute('/_app/seguranca/usuarios/$userId/permissoes')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/seguranca/usuarios/$userId', params, search: { tab: 'permissoes' } });
  },
});
